// @ts-check
// Risco de evasão com os principais sinais, no "Quem é" da Caixa (contrato 10 de atendimento, seção 24.2). Recebe a parte
// `retention` da resposta do "Quem é" (seção 18): sem ela (papel ou módulo), não aparece nada.
import { html } from 'htm/preact';
import { Link } from '../../app/router.js';
import { Icon } from '../../ui/icon.js';
import { formatDate } from '../../lib/format.js';
import { t } from '../../i18n/index.js';
import { RetentionRiskTag } from './household-retention-section.js';

/**
 * @param {{ householdId: string | null, retention: { score: number, risk: string | null, openCaseTicketId: string | null,
 *   topSignals: Array<{ signalKey: string, occurredAt: string }> } | null, isEmbedded?: boolean }} props
 *   isEmbedded: dentro de uma seção que já mostra o título, o selo do risco e o caso (o "Quem é" da Caixa): só os sinais
 */
export function HouseholdRetentionSummary({ householdId, retention, isEmbedded = false }) {
  if (!retention) return null;
  if (isEmbedded && retention.topSignals.length === 0) return null;
  return html`<div class="retention-summary" data-testid="household-retention-summary" data-embedded=${isEmbedded ? 'true' : undefined}>
    ${isEmbedded ? null : html`<div class="retention-summary-head">
      <span class="retention-summary-title"><${Icon} name="IconHeartHandshake" size=${14} />${t('retention.summary.title')}</span>
      <${RetentionRiskTag} risk=${retention.risk} score=${retention.score} />
    </div>`}
    ${retention.topSignals.length > 0
      ? html`<ul class="retention-summary-signals">
          ${retention.topSignals.map((signal) => html`<li key=${`${signal.signalKey}:${signal.occurredAt}`}>
            ${t(`retention.signals.${signal.signalKey}`)} <span class="retention-muted">${formatDate(signal.occurredAt)}</span>
          </li>`)}
        </ul>`
      : null}
    ${isEmbedded ? null : retention.openCaseTicketId
      ? html`<${Link} href=${`/object/serviceTicket/${retention.openCaseTicketId}`} className="retention-case-link">${t('retention.summary.openCase')}<//>`
      : householdId ? html`<${Link} href=${`/object/household/${householdId}`} className="retention-case-link">${t('retention.page.openFamily')}<//>` : null}
  </div>`;
}
